// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
app-text-input .form-group {
  margin-bottom: 5px;
}
.spacer {
  height: 30px;
}
.form-label {
  text-align: right;
  padding-right: 30px;
}
form {
  background-color: #efeff7;
}
`, "",{"version":3,"sources":["webpack://./src/app/clients-module/clients-add/clients-add.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;AADF;AAGA;EACE,kBAAA;AADF;AAGA;EACE,YAAA;AADF;AAIA;EACE,iBAAA;EACA,mBAAA;AAFF;AAKA;EACE,yBAAA;AAHF","sourcesContent":["@import (reference) url('../../../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\napp-text-input .form-group {\n  margin-bottom: 5px;\n}\n.spacer {\n  height: 30px;\n}\n\n.form-label {\n  text-align: right;\n  padding-right: 30px;\n}\n\nform {\n  background-color: #efeff7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
